/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Tab_StylesInputs */



/**
* | output |
* | --- |
* | "Styles" |
*
* @param {Quicktools_Tab_StylesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_tab_styles = /** @type {((inputs?: Quicktools_Tab_StylesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Tab_StylesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Styles")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stile")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stili")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Стили")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estilos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("款式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शैलियों")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Estilos")
	return /** @type {LocalizedString} */ ("Styles")
});